import { Flex, Image, Text } from '@mantine/core'
import classes from './FooterSimple.module.scss'
import LOGO from '../../../../public/images/logo.png'
import pkg from 'package.json' assert { type: 'json' }
export function FooterSimple() {
  return (
    <Flex direction={'column'} className={classes.footer}>
      <Flex
        className={classes.inner}
        pos={'relative'}
        direction={'column'}
        align={'center'}
        justify={'center'}
      >
        <Image
          width="80px"
          height="80px"
          src={LOGO.src}
          alt="Logo"
          styles={{
            image: {
              margin: 0,
              display: 'block',
            },
          }}
        />
        <Text color="dimmed" size="xs">
          v{pkg.version}
        </Text>
      </Flex>
    </Flex>
  )
}
